import {fetch} from '@/base-http'
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import OmnisearchResultSet from '@/modules/omnisearch/store/OmnisearchResultSet';

/**
 * Solicita una búsqueda genérica de resultados
 *
 * @param term {string} Termino de búsqueda
 */
export async function search (term: string) {
    const results = await fetch('/prologue/omnisearch', {
        params: { term },
    })

    return results.map((set: KeyValuePair) => OmnisearchResultSet.deserialize(set))
}
